import React, { useState, useEffect } from 'react';
import { X, Save, Globe, Server, Calendar, } from 'lucide-react';

export default function DomainModal({ isOpen, onClose, onSave, domain = null }) {
  const [formData, setFormData] = useState({
    domainName: '',
    registrar: 'Namecheap',
    hostingProvider: 'Hostinger',
    category: 'Production SaaS',
    // Domain Registrar Logins
    domainLoginUrl: '',
    domainUsername: '',
    domainPassword: '',
    // Hosting Logins
    hostingLoginUrl: '',
    hostingUsername: '',
    hostingPassword: '',
    ipAddress: '',
    nameServers: '',
    purchaseDate: new Date().toISOString().split('T')[0],
    renewalDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    hostingRenewDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    amcAmount: 0,
    cost: 1199,
    hostingCost: 0,
    billingCycle: 'yearly',
    autoRenew: true,
    amcPaidYear: new Date().getFullYear() - 1,
    notes: '',
    clientName: '',
    whatsappNo: '',
    madeBy: ''
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (domain) {
      setFormData({
        domainName: domain.domainName || '',
        registrar: domain.registrar || 'Namecheap',
        hostingProvider: domain.hostingProvider || 'Hostinger',
        category: domain.category || 'General',

        domainLoginUrl: domain.domainLoginUrl || domain.loginUrl || '',
        domainUsername: domain.domainUsername || domain.username || '',
        domainPassword: domain.domainPassword || domain.password || '',

        hostingLoginUrl: domain.hostingLoginUrl || domain.loginUrl || '',
        hostingUsername: domain.hostingUsername || domain.username || '',
        hostingPassword: domain.hostingPassword || domain.password || '',

        ipAddress: domain.ipAddress || '',
        nameServers: Array.isArray(domain.nameServers) ? domain.nameServers.join(', ') : (domain.nameServers || ''),
        purchaseDate: domain.purchaseDate || new Date().toISOString().split('T')[0],
        renewalDate: domain.renewalDate || new Date().toISOString().split('T')[0],
        hostingRenewDate: domain.hostingRenewDate || new Date().toISOString().split('T')[0],
        amcAmount: domain.amcAmount !== undefined ? domain.amcAmount : 0,
        cost: domain.cost !== undefined ? domain.cost : 1199,
        hostingCost: domain.hostingCost ?? 0,
        billingCycle: domain.billingCycle || 'yearly',
        autoRenew: domain.autoRenew !== undefined ? domain.autoRenew : true,
        amcPaidYear: domain.amcPaidYear ?? (new Date().getFullYear() - 1),
        notes: domain.notes || '',
        clientName: domain.clientName || '',
        whatsappNo: domain.whatsappNo || '',
        madeBy: domain.madeBy || ''
      });
    } else {
      setFormData({
        domainName: '',
        registrar: 'Namecheap',
        hostingProvider: 'Hostinger',
        category: 'Production SaaS',
        domainLoginUrl: '',
        domainUsername: '',
        domainPassword: '',
        hostingLoginUrl: '',
        hostingUsername: '',
        hostingPassword: '',
        ipAddress: '',
        nameServers: '',
        purchaseDate: new Date().toISOString().split('T')[0],
        renewalDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        hostingRenewDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        amcAmount: 0,
        cost: 1199,
        hostingCost: 0,
        billingCycle: 'yearly',
        autoRenew: true,
        amcPaidYear: new Date().getFullYear() - 1,
        notes: '',
        clientName: '',
        whatsappNo: '',
        madeBy: ''
      });
    }
  }, [domain, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.domainName.trim()) {
      alert('Please enter a domain name');
      return;
    }
    setLoading(true);
    await onSave(formData);
    setLoading(false);
  };

  const popularRegistrars = ['Namecheap', 'GoDaddy', 'Cloudflare', 'Porkbun', 'Hostinger', 'Google Domains', 'NameSilo', 'AWS Route 53', 'Other'];
  const popularHosting = ['Hostinger', 'AWS (Amazon Web Services)', 'Vercel', 'DigitalOcean', 'Bluehost', 'Hetzner', 'cPanel / WHM', 'Netlify', 'Render', 'Other'];
  const categories = ['Production SaaS', 'E-Commerce', 'Client Project', 'Internal Tools', 'Research / AI', 'Personal Portfolio', 'Blog / Content'];

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '720px' }}>
        {/* Modal Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#f8fafc'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Globe size={22} color="#4f46e5" />
            <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a' }}>
              {domain ? 'Edit Domain & Hosting Details' : 'Add New Domain Details'}
            </h2>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Modal Form */}
        <form onSubmit={handleSubmit} style={{ padding: '24px' }}>
          {/* Row 1: Domain Name & Category */}
          <div className="modal-grid-2-1">
            <div className="form-group">
              <label className="form-label">Domain Name *</label>
              <input
                type="text"
                name="domainName"
                value={formData.domainName}
                onChange={handleChange}
                placeholder="e.g. mycompany.com"
                className="form-control"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Category</label>
              <select name="category" value={formData.category} onChange={handleChange} className="form-control">
                {categories.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>

          {/* Row 2: Registrar & Hosting Platforms */}
          <div className="modal-grid-2">
            <div className="form-group">
              <label className="form-label">Domain Registrar Platform</label>
              <input
                type="text"
                name="registrar"
                value={formData.registrar}
                onChange={handleChange}
                className="form-control"
                list="registrar-options"
                placeholder="Namecheap, GoDaddy, Cloudflare..."
              />
              <datalist id="registrar-options">
                {popularRegistrars.map(r => <option key={r} value={r} />)}
              </datalist>
            </div>
            <div className="form-group">
              <label className="form-label">Hosting Platform</label>
              <input
                type="text"
                name="hostingProvider"
                value={formData.hostingProvider}
                onChange={handleChange}
                className="form-control"
                list="hosting-options"
                placeholder="Hostinger, AWS, Vercel..."
              />
              <datalist id="hosting-options">
                {popularHosting.map(h => <option key={h} value={h} />)}
              </datalist>
            </div>
          </div>

          {/* Section: Dates & Pricing */}
          <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
            <h4 style={{ fontSize: '0.85rem', color: '#4f46e5', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Calendar size={14} /> Renewal & Billing Info (Rupees ₹)
            </h4>
            <div className="modal-grid-2" style={{ marginBottom: '16px' }}>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Domain Renew Date *</label>
                <input
                  type="date"
                  name="renewalDate"
                  value={formData.renewalDate}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Domain Renewal Cost (₹)</label>
                <input
                  type="number"
                  step="1"
                  name="cost"
                  value={formData.cost}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g. 1199"
                />
              </div>
            </div>

            <div className="modal-grid-2">
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Hosting Renew Date *</label>
                <input
                  type="date"
                  name="hostingRenewDate"
                  value={formData.hostingRenewDate}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Hosting Renewal Cost (₹)</label>
                <input
                  type="number"
                  step="1"
                  name="hostingCost"
                  value={formData.hostingCost}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g. 299"
                />
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  id="autoRenew"
                  name="autoRenew"
                  checked={formData.autoRenew}
                  onChange={handleChange}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                <label htmlFor="autoRenew" style={{ fontSize: '0.85rem', color: '#0f172a', cursor: 'pointer', fontWeight: '500' }}>
                  Auto-Renew Enabled at Registrar
                </label>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="checkbox"
                  id="hasAmc"
                  checked={formData.amcAmount > 0}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      amcAmount: e.target.checked ? 4000 : 0
                    });
                  }}
                  style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#4f46e5' }}
                />
                <label htmlFor="hasAmc" style={{ fontSize: '0.85rem', color: '#0f172a', cursor: 'pointer', fontWeight: '700' }}>
                  Has AMC (₹4,000/yr)
                </label>
              </div>

              {formData.amcAmount > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    id="amcPaid"
                    checked={formData.amcPaidYear >= new Date().getFullYear()}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        amcPaidYear: e.target.checked ? new Date().getFullYear() : new Date().getFullYear() - 1
                      });
                    }}
                    style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#16a34a' }}
                  />
                  <label htmlFor="amcPaid" style={{ fontSize: '0.85rem', color: '#0f172a', cursor: 'pointer', fontWeight: '700' }}>
                    AMC Paid for Current Year ({new Date().getFullYear()})
                  </label>
                </div>
              )}
            </div>
          </div>

          {/* Section 1: Domain Registrar Logins */}
          <div style={{ background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
            <h4 style={{ fontSize: '0.85rem', color: '#4338ca', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Globe size={14} /> Domain Registrar Login Credentials
            </h4>
            <div className="form-group">
              <label className="form-label">Domain Portal Login URL</label>
              <input
                type="url"
                name="domainLoginUrl"
                value={formData.domainLoginUrl}
                onChange={handleChange}
                placeholder="https://ap.www.namecheap.com or https://sso.godaddy.com"
                className="form-control"
              />
            </div>
            <div className="modal-grid-2">
              <div className="form-group">
                <label className="form-label">Domain Login Username</label>
                <input
                  type="text"
                  name="domainUsername"
                  value={formData.domainUsername}
                  onChange={handleChange}
                  placeholder="domain_admin@email.com"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Domain Login Password</label>
                <input
                  type="text"
                  name="domainPassword"
                  value={formData.domainPassword}
                  onChange={handleChange}
                  placeholder="Domain account password"
                  className="form-control"
                />
              </div>
            </div>
          </div>

          {/* Section 2: Hosting Platform Logins */}
          <div style={{ background: '#ecfeff', border: '1px solid #cff4fc', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
            <h4 style={{ fontSize: '0.85rem', color: '#0891b2', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Server size={14} /> Hosting Platform Login Credentials
            </h4>
            <div className="form-group">
              <label className="form-label">Hosting Control Panel URL</label>
              <input
                type="url"
                name="hostingLoginUrl"
                value={formData.hostingLoginUrl}
                onChange={handleChange}
                placeholder="https://hpanel.hostinger.com or https://aws.amazon.com/console"
                className="form-control"
              />
            </div>
            <div className="modal-grid-2">
              <div className="form-group">
                <label className="form-label">Hosting Username</label>
                <input
                  type="text"
                  name="hostingUsername"
                  value={formData.hostingUsername}
                  onChange={handleChange}
                  placeholder="hosting_user@email.com"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Hosting Password</label>
                <input
                  type="text"
                  name="hostingPassword"
                  value={formData.hostingPassword}
                  onChange={handleChange}
                  placeholder="cPanel / Server password"
                  className="form-control"
                />
              </div>
            </div>
          </div>

          {/* Section: Technical & Notes */}
          <div className="modal-grid-2" style={{ marginBottom: '16px' }}>
            <div className="form-group">
              <label className="form-label">Server IP Address</label>
              <input
                type="text"
                name="ipAddress"
                value={formData.ipAddress}
                onChange={handleChange}
                placeholder="192.168.1.1"
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Nameservers (Comma separated)</label>
              <input
                type="text"
                name="nameServers"
                value={formData.nameServers}
                onChange={handleChange}
                placeholder="ns1.cloudflare.com, ns2.cloudflare.com"
                className="form-control"
              />
            </div>
          </div>

          {/* Section: Client & WhatsApp & Made By Details */}
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
            <h4 style={{ fontSize: '0.85rem', color: '#16a34a', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              Client Information & Contact
            </h4>
            <div className="modal-grid-2">
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">Client Name</label>
                <input
                  type="text"
                  name="clientName"
                  value={formData.clientName}
                  onChange={handleChange}
                  placeholder="e.g. John Doe"
                  className="form-control"
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">WhatsApp Number</label>
                <input
                  type="text"
                  name="whatsappNo"
                  value={formData.whatsappNo}
                  onChange={handleChange}
                  placeholder="e.g. 919876543210 (with country code)"
                  className="form-control"
                />
              </div>
            </div>
            {/* Made By */}
            <div className="form-group" style={{ marginTop: '12px', marginBottom: 0 }}>
              <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                🛠️ Website Made By / Developer
              </label>
              <input
                type="text"
                name="madeBy"
                value={formData.madeBy}
                onChange={handleChange}
                placeholder="e.g. Go2Web Solution, Freelancer Name, In-House Team..."
                className="form-control"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Notes / Remarks</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              rows={2}
              placeholder="Important remarks, client details, SSL certificates..."
              className="form-control"
            />
          </div>

          {/* Modal Actions */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              <Save size={16} />
              <span>{loading ? 'Saving...' : 'Save Domain Details'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
